import { GrayBackground } from 'components/base/layout-components';
import styled from 'styled-components';

export const StyledTableWrapper = styled.div`
  .MuiTableHead-root .MuiTableRow-root:first-child {
    border-top: 0;
  }
  ${({ loading }) =>
    loading &&
    `
  pointer-events: none;
  opacity: 0.5;
  z-index: 1;`}
`;

export const StyledBackground = styled(GrayBackground)`
  height: 100%;
`;

export const StyledTableActions = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  padding: 2rem;
`;

export const StyledNoMatchingResult = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-size: 1.6rem;
  font-weight: bold;
  color: gray;
  padding: 4rem 0;
`;
